import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './DatePicker.css';
import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import { addDays } from "date-fns";
import { ar, ru, cs, nl, fi, de, ja, nb, pt, sv, zhCN, da, fr, it, ko, pl, ro, es, uk, tr, enUS } from 'date-fns/locale';
import { ReactComponent as IconArrowLeft } from '../../../resources/icons/IconArrowLeft.svg';
import { ReactComponent as IconArrowRight } from '../../../resources/icons/IconArrowRight.svg';
import { ReactComponent as IconClose } from '../../../resources/icons/close.svg';
var langHash = {
  ar: ar,
  ru: ru,
  cs: cs,
  nl: nl,
  fi: fi,
  de: de,
  ja: ja,
  no: nb,
  pt: pt,
  sv: sv,
  zh: zhCN,
  da: da,
  fr: fr,
  it: it,
  ko: ko,
  pl: pl,
  ro: ro,
  es: es,
  uk: uk,
  tr: tr,
  en: enUS
};
var getStringFullDate = function getStringFullDate(date) {
  return date.toLocaleString(undefined, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};
var getStringWeek = function getStringWeek(date, lang) {
  return date.toLocaleString(lang ? langHash[lang] : undefined, {
    weekday: 'long'
  });
};
var emptyDateShowObj = {
  day: '',
  dayNumber: '',
  month: '',
  monthNumber: '',
  year: '',
  fullDate: new Date()
};
var DatePickerDropDown = function DatePickerDropDown(_ref) {
  var lang = _ref.lang,
    rtl = _ref.rtl,
    dateOpened = _ref.dateOpened,
    closeDateDropdown = _ref.closeDateDropdown,
    closeDateDropdownWithAnalytics = _ref.closeDateDropdownWithAnalytics,
    setDepDate = _ref.setDepDate,
    isMobile = _ref.isMobile,
    dateMobileDateText = _ref.dateMobileDateText,
    changeWeatherDataHandler = _ref.changeWeatherDataHandler;
  var _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    singleDate = _useState2[0],
    setSingleDate = _useState2[1];
  var renderCustomHeader = function renderCustomHeader(props) {
    var monthDate = props.monthDate,
      decreaseMonth = props.decreaseMonth,
      increaseMonth = props.increaseMonth,
      nextMonthButtonDisabled = props.nextMonthButtonDisabled,
      prevMonthButtonDisabled = props.prevMonthButtonDisabled;
    return /*#__PURE__*/React.createElement("div", {
      className: "react-datepicker__header-month"
    }, /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__current-month"
    }, monthDate.toLocaleString(langHash[lang] ? langHash[lang].code : 'en-US', {
      month: "long",
      year: "numeric"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Previous Month",
      className: "\n          react-datepicker__navigation react-datepicker__navigation--previous\n          ".concat(isMobile ? 'd-none' : '', "\n          ").concat(prevMonthButtonDisabled ? 'd-none' : '', "\n        "),
      onClick: decreaseMonth
    }, /*#__PURE__*/React.createElement(IconArrowLeft, {
      className: "icon"
    })), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Next Month",
      className: "\n          react-datepicker__navigation react-datepicker__navigation--next\n          ".concat(isMobile ? 'd-none' : '', "\n          ").concat(nextMonthButtonDisabled ? 'd-none' : '', "\n        "),
      onClick: increaseMonth
    }, /*#__PURE__*/React.createElement(IconArrowRight, {
      className: "icon"
    })));
  };
  var renderDayContents = function renderDayContents(day, date) {
    return /*#__PURE__*/React.createElement("span", {
      className: "react-datepicker__day-text"
    }, date.getDate());
  };
  var generateDateObj = function generateDateObj(date) {
    return date ? {
      day: date.toLocaleString(undefined, {
        day: "numeric"
      }),
      dayNumber: date.toLocaleString(undefined, {
        day: "2-digit"
      }),
      month: date.toLocaleString(langHash[lang] ? langHash[lang].code : 'en-US', {
        month: "long"
      }),
      monthNumber: date.toLocaleString('en-US', {
        month: "2-digit"
      }),
      year: date.toLocaleString(undefined, {
        year: "numeric"
      }),
      fullDate: date
    } : emptyDateShowObj;
  };
  useEffect(function () {
    setDepDate && setDepDate(generateDateObj(singleDate));
  }, [singleDate]);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    opened: dateOpened
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-close d-none d-md-block",
    onClick: closeDateDropdownWithAnalytics
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none dropdown-header"
  }, /*#__PURE__*/React.createElement("button", {
    className: "dropdown-header__back",
    onClick: closeDateDropdownWithAnalytics
  }, rtl ? /*#__PURE__*/React.createElement(IconArrowRight, {
    className: "icon"
  }) : /*#__PURE__*/React.createElement(IconArrowLeft, {
    className: "icon"
  })), /*#__PURE__*/React.createElement("h2", {
    className: "dropdown-header__text"
  }, dateMobileDateText)), /*#__PURE__*/React.createElement("div", {
    className: "datepicker-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "datepicker-body__head-wrapper d-none d-md-flex"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "datepicker-body__head"
  }, dateMobileDateText)), /*#__PURE__*/React.createElement(DatePicker, {
    inline: !!dateOpened,
    monthsShown: isMobile ? 10 : 1,
    locale: langHash[lang],
    renderCustomHeader: renderCustomHeader,
    selected: singleDate,
    minDate: new Date(),
    maxDate: addDays(new Date(), 299),
    renderDayContents: renderDayContents,
    onChange: function onChange(date) {
      setSingleDate(date);
      changeWeatherDataHandler(date);
      closeDateDropdown();
    }
  })));
};
var commonStyles = "c1hp98uz";
var ltrStyles = "lj1r4ux";
var rtlStyles = "r1lwdciw";
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    opened = _ref2.opened;
  return /*#__PURE__*/React.createElement("div", {
    className: "\n  datepicker-dropdown\n  ".concat(commonStyles, "\n  ").concat(rtl ? rtlStyles : ltrStyles, "\n  ").concat(opened ? 'datepicker-dropdown--opened' : '', "\n")
  }, children);
};
export { DatePickerDropDown, getStringFullDate, getStringWeek, emptyDateShowObj };